/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowCollapseCVClosedIcon24Solid = forwardRef('ArrowCollapseCVClosedIcon24Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { d: "M14.828 9.79a4 4 0 0 1-5.657 0l-5.23-5.23a1.5 1.5 0 0 1 2.122-2.12l5.23 5.23a1 1 0 0 0 1.414 0l5.23-5.23a1.5 1.5 0 1 1 2.121 2.12l-5.23 5.23Z" }),
        React.createElement("path", { d: "M14.828 14.21a4 4 0 0 0-5.657 0l-5.23 5.23a1.5 1.5 0 0 0 2.122 2.12l5.23-5.23a1 1 0 0 1 1.414 0l5.23 5.23a1.5 1.5 0 0 0 2.121-2.12l-5.23-5.23Z" })));
});
